import React from 'react';
import styles from './LineFeatureToolbar.module.css';

const LineFeatureToolbar = ({ plantName }) => {
  return (
    <>
      <div className={styles.RgtTools}>
        <div className={styles.lineFeatureToolbar}>
          <div className={styles.plantName}>
            Selected Plant - {plantName}
          </div>
        </div>
      </div>
    </>
  );
};

export default LineFeatureToolbar;